import { render, staticRenderFns } from "./key_behaviors.vue?vue&type=template&id=7a6ff011&scoped=true"
import script from "./key_behaviors.vue?vue&type=script&lang=js"
export * from "./key_behaviors.vue?vue&type=script&lang=js"
import style0 from "./key_behaviors.vue?vue&type=style&index=0&id=7a6ff011&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6ff011",
  null
  
)

export default component.exports